import React, { Component } from 'react'
import { withDomains, RESTExecutor } from '../../lib/domain'
import { Link } from 'react-router-dom';
import { Typography, Table, Row, Button, Divider, Input, Spin, Tag, Badge, message } from 'antd';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../lib/util';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { StarOutlined, StarBorder, StorageOutlined, InsertDriveFileOutlined, LayersOutlined, WifiTetheringOutlined } from '@material-ui/icons';
import {TransparentButton} from '../../components/basic_items';
import { recon_quick_menu } from '../../util/ui_util';
import moment from 'moment';
import { COLORS } from '../theme';
import DayDifferennceTag from '../../components/day_difference_tag';


const queryString = require('query-string');


class GroupList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {}
        };
        this.list_groups = RESTExecutor.list().config({
            label: 'grouped_reconcilers',
            params: {
                per_page: 100
            }
        }).connect(props.domains.usergroups);

        this.mark_favourite = RESTExecutor.post().config({
            label: 'mark_fav'
        }).callbacks((success) => {
            message.success("Marked Favourite");
            this.list_groups.execute();
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.usergroups);


        this.unmark_favourite = RESTExecutor.post().config({
            label: 'unmark_fav'
        }).callbacks((success) => {
            message.success("Removed Favourite");
            this.list_groups.execute();
        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.usergroups);

        this.delay_search = new NetworkDelaySearch();




    };

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }



    render() {
        let list_group_resp = this.list_groups.response();
        let list_group_data = list_group_resp.result || {};
        let rowsData = list_group_data.rows || [];
        let rowsMeta = list_group_resp.meta || {};
        const { filter_query } = this.state;

        return (
            <ErrorWrapper
                error={list_group_resp}
                onReload={() => {
                    this.list_groups.execute()
                }}>
                <BasicHeader
                    no_back
                    title="Groups Overview"
                    menu_items={recon_quick_menu}

                    
                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                            }} 
                            // autoFocus
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {

                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })

                                    }
                                })
                            }} />
                    </div>
                </div>
                
               
                <div className='default-card' style={{
                    // padding: 8
                }}>
                    <Table
                        // rowClassName='hand-cursor'
                        className='main-table '
                        loading={list_group_resp.fetching}
                        size='small'
                        rowClassName={'hand-cursor'}
                        scroll={{ x: true }}
                        onRow={(record,index)=>{
                            return {
                                onClick:(e)=>{
                                    this.props.history.push(`/recon/groups/${record.group_id}/sources`)
                                }
                            }
                        }}
                        pagination={{
                            // simple: true,
                            position:'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })

                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),

                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        rowKey={(record) => record.id}
                        // expandedRowRender={(record,index,indent,expanded)=>{
                        //     if(expanded){
                        //         return <SourcesForReconciler 
                        //         key={`${index}`}
                        //         data={record}
                        //         />
                        //     }
                        // }}
                        columns={[
                            // {
                            //     title: <StarBorder titleAccess='Favourite' className='star-inactive hand-cursor'/>,
                            //     width:70,
                            //      dataIndex: 'favourite', key: 'favourite', render: (favourite, record) => {
                            //         return <StarBorder
                            //             className={favourite ? 'star-active hand-cursor' : 'star-inactive hand-cursor'}
                            //             titleAccess="Toggle Favourite"

                            //             onClick={() => {
                            //                 if (favourite) {
                            //                     this.unmark_favourite.forId(record.id).execute();
                            //                 } else {
                            //                     this.mark_favourite.forId(record.id).execute()
                            //                 }
                            //             }}
                            //         />
                            //     }
                            // },
                            {
                                title: "NAME", dataIndex: 'rule_name', key: 'name',
                                className:'bold-cell',
                                render: (value, record) => {
                                    return <span>{record.group_name}</span>
                                }
                            },
                            {
                                title:"Total Unreconciled",
                                dataIndex:'unreconciled',
                                key:'unreconciled',
                                className:'right-align',
                                render:(value,data)=>{
                                  return formatMoney(value,0)
                                }
                              },
                              {
                                title:"Total Pending",
                                dataIndex:'pending',
                                key:'pending',
                                className:'right-align',
                                render:(value,data)=>{
                                    return formatMoney(value,0)
                                }
                              },
                            //   {
                            //     title:"Reconciled(last 7 days)",
                            //     dataIndex:'reconciled',
                            //     key:'reconciled',
                            //     className:'right-align',
                            //     render:(value,data)=>{
                            //         return formatMoney(value,0)
                            //     }
                            //   },
                              {
                                title:"Last Reconciled",
                                dataIndex:'reconciled_at',
                                key:'reconciled_at',
                                className:'center-align',
                                width:160,
                                render:(value,data)=>{
                                    // let value="2020-07-03 11:11AM"
                                    if(moment(value,"YYYY-MM-DD A").isValid()){
                                        let day_difference=-moment(value,"YYYY-MM-DD A").diff(moment(),"day");
                                        return <div style={{
                                            display:'flex',
                                            flexDirection:'row',
                                            alignItems:'center',
                                            justifyContent:'center'
                                        }}> <DayDifferennceTag 
                                        date={value} 
                                        dateFormat="YYYY-MM-DD A" 
                                        // maxSuccessDay={547}
                                        // dateFrom={'2022-02-01'}
                                        />
                                        </div>
                                        // <div style={{
                                        //     display: 'flex',
                                        //     flexDirection: 'row',
                                        //     justifyContent:'flex-end',
                                        //     flexWrap:'nowrap'
                                        // }}
                                        // title={value}
                                        // >
                                        //     <span 
                                        //      style={{
                                        //         color:COLORS.success_primary
                                        //     }}>
                                        //         {day_difference>0?`${moment(value,"YYYY-MM-DD hh:ss A").fromNow()}`:"Today"}
                                        //         </span>
                                        // </div>
                                    }else return ""
                                    
                                }
                              },
                            // { title: "Description", dataIndex: 'description', key: 'description'},
                            // {
                            //     title:"Datatypes",
                            //     dataIndex:'data_type_count',
                            //     key:'data_type_count',
                            //     className:'right-align',
                            //     width:50,
                            //     render:(value,data)=>{
                            //       return formatMoney(value,0)
                            //     }
                            //   },
                            //   {
                            //     title:"Reconcilers",
                            //     dataIndex:'reconciler_count',
                            //     key:'reconciler_count',
                            //     className:'right-align',
                            //     width:50,
                            //     render:(value,data)=>{
                            //         return formatMoney(value,0)
                            //     }
                            //   },
                            //   {
                            //     title:"Sources",
                            //     dataIndex:'source_count',
                            //     key:'source_count',
                            //     className:'right-align',
                            //     width:50,
                            //     render:(value,data)=>{
                            //         return formatMoney(value,0)
                            //     }
                            //   },
                            // {
                            //     title: "ACTION",width:80, dataIndex: "group_id", key: 'id', render: (id) => {
                            //         return <div style={{
                            //             display:'flex',
                            //             flexDirection:'row',
                            //             alignItems:'center'
                            //         }}> <Link to={{
                            //             pathname: `/recon/groups/${id}/sources`,
                            //             // search: `datatype=${id}`
                            //         }}
                            //         style={{color:'inherit'}}
                            //         >
                            //             <Button type='link'>Dashboard</Button>
                            //           </Link>
                            //         </div>
                            //     }
                            // },
                        ]}
                        dataSource={rowsData}
                    />
                </div>
            </ErrorWrapper>
        )
    }

    componentDidMount() {
        // this.list_groups.execute();
        overrideHeaderTitle("Datatype List");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_groups.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })

    }
    componentWillUnmount() {
    }
    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_groups.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }
}

export default withDomains(GroupList, "usergroups")


class _SourcesForReconciler extends Component{
    constructor(props) {
        super(props)
    
        this.state = {
             rowsData:[],
             rowsMeta:{},
             loading:false
        }


    }
    
    render(){
        const {rowsData,rowsMeta,loading}=this.state;
        return <div>
             <Table
                        // rowClassName='hand-cursor'
                        className='main-table noHover'
                        loading={loading}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            // simple: true,
                            position:'bottom',
                            onChange: (current, size) => {
                                // this.props.history.push({
                                //     search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                // })

                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),

                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        rowKey={(record) => record.id}
                        columns={[
                            { title: "Source", dataIndex: 'name', key: 'name'},
                            {
                                title:"Total Unreconciled",
                                dataIndex:'data_type_count',
                                key:'data_type_count',
                                className:'right-align',
                                render:(value,data)=>{
                                  return formatMoney(value,0)
                                }
                              },
                              {
                                title:"Total Pending",
                                dataIndex:'reconciler_count',
                                key:'reconciler_count',
                                className:'right-align',
                                render:(value,data)=>{
                                    return formatMoney(value,0)
                                }
                              },
                              {
                                title:"Reconciled(last 7 days)",
                                dataIndex:'reconciler_count',
                                key:'reconciler_count',
                                className:'right-align',
                                render:(value,data)=>{
                                    return formatMoney(value,0)
                                }
                              },
                              {
                                title:"Last Reconciled",
                                dataIndex:'reconciler_count',
                                key:'reconciler_count',
                                className:'right-align',
                                render:(value,data)=>{
                                    return formatMoney(value,0)
                                }
                              },
                            {
                                title: "ACTION",width:80, dataIndex: "id", key: 'id', render: (id) => {
                                    return <div style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        alignItems:'center'
                                    }}> <Link to={{
                                        pathname: `/recon/groups/${id}/sources`,
                                        // search: `datatype=${id}`
                                    }}
                                    style={{color:'inherit'}}
                                    >
                                        <Button type='link'>View</Button>
                                      </Link>
                                    </div>
                                }
                            },
                        ]}
                        dataSource={rowsData}
                    />

        </div>
    }
}
const SourcesForReconciler=withDomains(_SourcesForReconciler,"usergroups");


